<template>
	<!-- 帳戶設定 -->
	<div class="deal_index_box">
		<!-- 内容 -->
		<div class="deal_title">
			<div>帳戶設定<span>》</span>商家資訊</div>
			<div class="deal_hr">
				<div class="cut_off"></div>
			</div>
		</div>
		<!-- 基本帳戶資訊 -->
		<div class="deal_content_box">
			<div class="deal_content_title">基本帳戶資訊</div>
			<div class="deal_content div_hight_end">
				<el-row class="list_high_end">
					<el-col :span="5" :xs="8">
						商家編號：<span>{{formS.uid}}</span>
					</el-col>
					<el-col :span="6" :xs="8">
						商家類型：<span>普通商家</span>
					</el-col>
				</el-row>

			</div>
		</div>
		<!-- 最高權限管理員資訊	 -->
		<div class="deal_content_box">
			<div class="deal_content_title">最高權限管理員資訊 <span class="icon_span" @click="gologinbseller()"></span></div>
			<div class="deal_content div_hight_end">
				<el-row class="list_high_end col_divs">
					<el-col>
						姓名：<span>{{formS.name}}</span>
					</el-col>
					<el-col>
						綁定手機：<span>{{formS.tel}}</span>
					</el-col>
					<el-col>
						綁定信箱：<span>{{formS.mailbox}}</span>
					</el-col>
					<el-col>
						新增跨行提領手續費：<span>{{formS.enjambment}}</span>
					</el-col>
				</el-row>
			</div>
		</div>
		<!-- 結算資訊 -->
		<div class="deal_content_box">
			<div class="deal_content_title">結算資訊 <span class="icon_span" @click="gologinbalan()"></span></div>
			<div class="deal_content div_hight_one period_maxbox">
				<div class="period_div">
					<div class="bank_box">
						<span>
							銀行戶名：{{formS.bankname}}
						</span>
						<span>
							銀行代碼：{{formS.banknumber}}
						</span>
						<span>
							所屬分行：{{formS.bankcode}}
						</span>
						<span>
							銀行帳號：{{formS.branch}}
						</span>
					</div>
					<div class="period_box">
						提領週期：{{settledFun()}}
						<span v-if=" settledFun() == '每週提領' ">
							：<span v-for="(item, index) in wList" :key="index">
								{{item}}
							</span>
						</span>
						<span v-if=" settledFun() == '每月提領' ">
							：<span v-for="(item, index) in mList" :key="index">
								{{item}}日
							</span>
						</span>
						<span class="span_gray">
							（您設定的自動提領週期為{{settledFun()}}，系統將在<span class="span_red">第二天凌晨4：00</span>自動提領您帳戶的可提領餘額）
						</span>
						<div class="table_box">
							<div class="table_header bottom_div">
								<span class="tb_branch">收款路徑</span>
								<span class="tb_review">結算週期</span>
								<span class="tb_num">費率</span>
								<span class="tb_num">手續費</span>
							</div>
							<div class="table_content" v-for="(item, index) in tBranch" :key="index">
								<span class="tb_branch">{{item.branch}}</span>
								<span class="tb_review">{{item.account_review}}</span>
								<span class="tb_num">{{item.type == '1'?item.num:'-'}}</span>
								<span class="tb_num">{{item.type == '2'?item.num:'-'}}</span>
							</div>
						</div>
						<div>
							<span class="span_gray bank_hint">
								提領須知：當用戶設定的提領時間與法定節假日相遇時，則順延至下一個工作日。
							</span>
						</div>
					</div>

				</div>

			</div>
		</div>
		<div class="deal_content_box">
		    <div class="deal_content_title">經營資料 <span class="icon_span" @click="gologinbhighesr()"></span></div>
			<div class="deal_content div_hight_one div_bottom">
				<div class="lest_hist">經營資料</div>
				<div class="dist_hites">
			<!-- 表单 -->
			<el-form class="form_mail"  label-width="130px" :model="formS">
				<el-form-item label="公司名稱：" class="form_items">
					{{formS.company}}
				</el-form-item>
				<el-form-item label="統一編號號：">
					{{formS.number}}
				</el-form-item>
				<el-form-item label="營業登記證：">
					<img class="img_to" :src="formS.business_license" alt="">
				</el-form-item>
				<el-form-item label="負責人姓名：">
					{{formS.principal}}
				</el-form-item>
				<el-form-item label="證件類型：">
					{{formS.paperwork_type == "1"? "國民身份證（限台灣）":"護照（限海外人士）"}}
				</el-form-item>
				<el-form-item label="證件正面照片：">
					<div>
						<img class="img_to" :src="formS.paperwork1" alt="">
					</div>
				</el-form-item>
				<el-form-item label="證件反面照片：">
					<div>
						<img class="img_to" :src="formS.paperwork2" alt="">
					</div>
				</el-form-item>
				<el-form-item label="身份證字號：">
					{{formS.code}}
				</el-form-item>
				<el-form-item label="發證日期：">
					民國***年*月{{formS.day}}日
				</el-form-item>
				<el-form-item label="發證地點：">
					{{formS.address}}
				</el-form-item>
				<el-form-item label="領補換類別：">
					***
				</el-form-item>
			</el-form>
		
		<div class="lest_hist dist_hites_tow">店家資料</div>
			<el-form class="form_mail"  label-width="130px" :model="formS">
				<el-form-item label="店家簡稱：">
					{{formS.storename}}
				</el-form-item>
				<el-form-item label="客服電話：">
					{{formS.kf_tel}}
				</el-form-item>
				<el-form-item label="經營類別：">
					{{formS.operate}}
				</el-form-item>
				<!-- 銷售通道 -->
				<el-form-item label="銷售通道：">
					<span class="sell_list_for" v-for="(item, index) of sellList" :key="index">
                    	<i class="el-icon-check icon_check_box"></i>
                    	{{item}}
                  	</span>
				</el-form-item>
			</el-form>
				
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import axios from 'axios';
	export default {
		name: 'LoginBusiness',
		data() {
			return {
				accountReview: '',
				flv: '',
				formS: {
					enjambment: '',
					uid: '',
					name: '',
					tel: '',
					mailbox: '',
					bankname: '',
					bankcode: '',
					branch: '',
					banknumber: '',
					company: '',
					number: '',
					business_license: '',
					principal: '',
					paperwork_type: '1',
					paperwork1: '',
					paperwork2: '',
					day: '1',
					code: '',
					address: '',
					storename: '',
					kf_tel: '',
					operate: '',
					sell: '',
					sellname: '',
				},
				settled: {
					status: '',
					date: '',
				},
				uid: '',
				tBranch: [],
				imgurl: 'http://pay.taiyigou.com.tw/attachment/',
				paymentslue: false,
				checkList: [],

				// return
			}
		},
		methods: {
			// 判斷日，周，月：
			settledFun(){
				if(this.settled.status == '1'){
					return '每天提領'
				} else if (this.settled.status == '2'){
					return '每週提領'
				} else {
					return '每月提領'
				}
			},
			
			gologinbalan() {
				this.$router.push('/login/account/loginbalan')
			},
			gologinbseller() {
				this.$router.push('/login/account/loginbseller')
			},
			gologinbhighesr() {
				this.$router.push('/login/account/loginbh')
			},

		},
		computed: {
			wList(){
				// 周：
				if(this.settled.status == '2'){
					let list = this.settled.date;
					list = list.split(",");
					let wlist = [];
					for(let i=0; i<list.length; i++){
						if(list[i] == '0'){
							wlist.push('星期日');
						} else if(list[i] == '1'){
							wlist.push('星期一');
						} else if(list[i] == '2'){
							wlist.push('星期二');
						} else if(list[i] == '3'){
							wlist.push('星期三');
						} else if(list[i] == '4'){
							wlist.push('星期四');
						} else if(list[i] == '5'){
							wlist.push('星期五');
						} else {
							wlist.push('星期六');
						}
					}
					return wlist
				} else {
					return []
				}
			},
			mList(){
				// 月：
				if(this.settled.status == '3'){
					let list = this.settled.date;
					list = list.split(",");
					return list
				} else {
					return []
				}
			},

			sellList(){
				if(this.formS.sell != null){
					let sell = this.formS.sell.split(",");
					return sell;	
				}
			}
		},
		created() {

			axios.get(this.$store.state.axiosBusinessUrl, {
				params: {
					uid:this.$store.state.uid,
					action: 1
				}
			}).then((res) => {
				// console.log(res.data);
				this.tBranch = res.data.message.branch_settled;
				this.settled.status = res.data.message.settled_status;
				this.settled.date = res.data.message.settled_date;
				this.accountReview = res.data.message.account_review;
				this.formS.enjambment = res.data.message.enjambment;
				this.flv = res.data.message.flv;
				this.formS.uid = res.data.message.uid;
				this.formS.name = res.data.message.name;
				this.formS.tel = res.data.message.tel;
				this.formS.mailbox = res.data.message.mailbox;
				this.formS.bankname = res.data.message.bankname;
				this.formS.bankcode = res.data.message.bankcode;
				this.formS.branch = res.data.message.branch;
				this.formS.banknumber = res.data.message.banknumber;
				this.formS.company = res.data.message.company;
				this.formS.number = res.data.message.number;
				this.formS.business_license = this.imgurl + res.data.message.business_license;
				this.formS.principal = res.data.message.principal;
				this.formS.paperwork_type = res.data.message.paperwork_type;
				this.formS.paperwork1 = this.imgurl + res.data.message.paperwork1;
				this.formS.paperwork2 = this.imgurl + res.data.message.paperwork2;
				this.formS.day = res.data.message.day;
				this.formS.code = res.data.message.code;
				this.formS.address = res.data.message.address;
				this.formS.storename = res.data.message.storename;
				this.formS.kf_tel = res.data.message.kf_tel;
				this.formS.operate = res.data.message.operate;
				this.formS.sell = res.data.message.sell;
				this.formS.sellname = res.data.message.sellname;
			})
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	/* 表頭 */
	.span_gray {
		color: #c5c5c5;
		margin-left: 20px;
	}
	.span_red {
		color: #e73262;
	}
	.icon_span {
		cursor: pointer;
	}
	.sell_list_for > i {
		margin-right: 5px;
	}
	.icon_check_box {
    	border: 1px solid #777;
  	}
	.el-form .el-form-item {
		margin-bottom: 10px;
	}
	.deal_index_box {
		margin: 20px;
		font-size: 15px;
		color: black;
	}

	.deal_title {
		display: flex;
		justify-content: flex-start;
		padding-bottom: 10px;
	}

	.deal_title span {
		margin-left: 15px;
		margin-right: 8px;
	}

	.deal_title .deal_hr {
		flex: 1;
		margin-left: 18px;
	}

	.deal_title .deal_hr .cut_off {
		height: 3px;
		background: black;
		margin-top: 8px;
	}

	/* 内容 */
	.col_divs {
		display: flex;
	}
	.period_maxbox {
		display: flex;
	}
	.period_div {
		min-width: 1000px;
	}
	.period_maxbox .bank_box {
		display: flex;
		justify-content: space-between;
	}
	.period_box {
		margin: 40px 0;
	}
	.span_box {
		display: flex;
		flex-direction: column;
	}
	/* 表單 */
	.table_box {
		margin: 46px 0;
		box-sizing: border-box;
		background: #f2f2f2;
		border: 1px solid #bebebe;
	}
	.bottom_div {
		border-bottom: 1px solid #bebebe;
	}
	.table_header, .table_content {
		display: flex;
		align-items: center;
		text-align: center;
		padding: 10px 0;
	}
	.table_header >span, .table_content >span {
		flex: 1;
	} 
	.bank_hint {
		display: flex;
		justify-content: flex-end;
	}
	.datetime_box>span {
		margin: 10px;
	}

	.deal_content_box {
		font-size: 13px;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.deal_content_title {
		height: 42px;
		background: #666666;
		line-height: 42px;
		color: white;
		padding-left: 14px;
	}

	.deal_content {
		box-sizing: border-box;
		/* height: 53.6vw; */
		/* min-height: 100px; */
		border: 1px solid #666666;
		background: #ffffff;
		padding: 0 20px;
		padding-top: 26px;
	}

	.deal_content_span {
		margin-left: 23px;
		font-size: 11px;
		color: #e73262;
	}

	.deal_content_tab_first {
		width: 960px;
		margin: 0 auto;
	}

	.deal_content_tab_first>div {
		margin: 14px 0;
	}

	.money_box span {
		margin: 0 10px;
	}

	.money_input {
		width: 140px;
		/* margin-left: 4px; */
	}

	.money_input01 {
		margin-left: 4px;
	}

	.inquire_button {
		padding: 10px 0;
	}



	/* 方塊顯示 */
	.list_high {
		color: #666666;
		display: flex;
		height: 36px;
		line-height: 36px;
		font-size: 13px;
	}

	.div_hight {
		padding-top: 10px;
	}

	.btn_lits {
		padding-top: 0px;
		padding-bottom: 0px;
		padding-left: 7px;
		padding-right: 7px;
		height: 16px;
		border-top-width: 1px;
		margin-top: 9px;
		margin-left: 10px;
		font-size: 11px;
		background: #e73262;
	}

	.div_hight_end {
		padding-top: 10px;

	}

	.list_high_end {
		line-height: 70px;
	}

	.div_hight_one {
		padding-top: 20px;
		padding-bottom: 30px;

	}

	.list_high_one {

		line-height: 35px;
	}

	.deal_content_title span {
		display: block;
		height: 35px;
		width: 30px;
		float: right;
		padding-left: 10px;
		padding-top: 5px;
		background: url("../../../../assets/img/user/service_list.png") center no-repeat;
	}

	.lstl_bock {
		height: 1px;
	}

	.div_left {
		padding-left: 60px;
	}

	/* 經營者資料 */
	.lest_hist {
		font-weight: 700;
		border-left: 10px solid #e73262;
		font-size: 15px;
		padding-left: 10px;
	}

	.list_new {
		padding-left: 30px;
	}

	.list_two {
		padding-left: 20px;
	}

	.div_bottom div {
		margin-bottom: 25px;
		color: #777777;
	}

	.img_title img {
		width: 260px;

	}

	.dist_hites_tow {
		margin: 30px;
	}

	.input_high .el-input .el-input__inner {
		height: 27px;
		border: 1px solid #cccccc;
	}

	.input_high {
		padding-left: 10px;
	}

	.check_right label {
		margin-right: 5px;
	}
	.img_to {
		max-width: 600px;
	}
</style>
